/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AwsServiceUploadPresignResponse } from "./AwsServiceUploadPresignResponse";

export type AwsServiceUploadPresignResponseApiRespoonse = {
  data?: AwsServiceUploadPresignResponse;
  status?: AwsServiceUploadPresignResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AwsServiceUploadPresignResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
